import { createReducer, on } from '@ngrx/store';
import { GlobalState } from "@store/global/global.state";
import { globalActions } from "@store/global/global.actions";

export const initialGlobalState: GlobalState = {
	isProcessing: false,
	isIndexing: false,
	steps: [],
	version: null,
	uiVersion: null,
};

export const globalReducers = createReducer(
	initialGlobalState,
	on(globalActions.loadedProcessing, (state, {processing}) => ({
		...state,
		isProcessing: processing?.length > 0,
		steps: processing
	})),
	on(globalActions.updateVersion, (state, {version}) => ({
		...state,
		version: version,
	})),
	on(globalActions.updateUIVersion, (state, {uiVersion}) => ({
		...state,
		uiVersion: uiVersion,
	}))
);
